import React, { useState } from 'react';
import { usePosts } from '../../hooks/usePosts';
import PostInfo from '../Blog/PostInfo';
import he from 'he';

const PostImg = ({ image }) => <img src={image} alt="Post" className="blog-home-card-img" />;

// Función helper para determinar posts por página
const getPostsPerPage = () => {
  // Usar optional chaining y un fallback para tests
  if (typeof window !== 'undefined' && window.matchMedia) {
    if (window.matchMedia('(max-width: 1025px)').matches) {
      return 2;
    }
  }
  return 3; // valor por defecto
};

export default function BlogHome() {
  const { posts } = usePosts();
  const [currentStartIndex, setCurrentStartIndex] = useState(0);

  if (!posts || posts.length === 0) {
    return <p>Loading posts...</p>;
  }

  const postsPerPage = getPostsPerPage();

  const totalPages = Math.ceil(posts.length / postsPerPage);

  const handleDotClick = index => {
    setCurrentStartIndex(index * postsPerPage);
  };

  const visiblePosts = posts.slice(currentStartIndex, currentStartIndex + postsPerPage);

  return (
    <div>
      <h3 className="custom-home-h3 gradient-color">
        Read the latest articles on our{' '}
        <a href="https://blog.disgenet.com/" className="gradient-color">
          blog
        </a>
      </h3>
      <hr></hr>
      <div className="blog-home-container">
        <div className="blog-home-cards">
          {visiblePosts.map(post => (
            <div key={post.postName} className="blog-home-card visible">
              <a href={`${post.link}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="post-thumbnail">
                  <PostImg image={post.image} />
                </div>
                <div className="blog-home-card-content">
                  <h3 className="blog-home-card-title gradient-color h3-post">{he.decode(post.title)}</h3>
                  <div className="post-info">
                    <PostInfo category={post.category} date={post.date} />
                  </div>
                  <p className="blog-home-card-description">{he.decode(post.description)}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
        <div className="slider-dots">
          {Array.from({ length: totalPages }).map((_, index) => (
            <div
              key={index}
              className={`slider-dot ${currentStartIndex / postsPerPage === index ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
